// extracted by mini-css-extract-plugin
module.exports = {"avatar":"SquadCatchUpItem_avatar__1n52r","linkToEmployee":"SquadCatchUpItem_linkToEmployee__spW5z"};